import useMixedItemDist from "@hooks/useMixedItemDist";
import { useMemo } from "react";
import { getProethicaOrderedEntries } from "../../helpers/proethica-module-list";
import { useProethicaModuleList } from "../../hooks/useProethicaModuleList";
import { ModulesList } from "../ModulesList";

type Props = {
	handleShowPurchase: () => void;
	viewMode?: "list" | "grid";
};

// The home modules list mirrors the Modules tab: the full live roster (8 modules
// incl. content-only Module 1 + the native pre/post tests) sourced from `exams`,
// not the mastery tags (which omit Module 1 and the tests).
export const ProethicaTopicsSection = ({
	handleShowPurchase,
	viewMode,
}: Props) => {
	const { data: mixedItemDist } = useMixedItemDist();
	const { getModuleListItemProps, startModule, resolveModuleItems } =
		useProethicaModuleList();

	const items = useMemo(
		() => resolveModuleItems(getProethicaOrderedEntries(mixedItemDist?.exams)),
		[mixedItemDist?.exams, resolveModuleItems],
	);

	return (
		<ModulesList
			items={items}
			handleSelectTopic={startModule}
			handleShowPurchase={handleShowPurchase}
			getModuleListItemProps={getModuleListItemProps}
			viewMode={viewMode}
		/>
	);
};
